import TweenLite from 'gsap/TweenLite';
import intersectionHelper from '../../../general/js/intersection-helper';
import BaseComponent from '../../../general/js/base-component';

export default class EnergyCertificateComponent extends BaseComponent{
    constructor() {
        super(...arguments);

        this.level = this.element.dataset.level;
        if (!this.level) {
            throw new Error('unknown data-level');
        }

        this.init();
    }

    init() {
        this.levels = [...this.element.children];

        this.activeLevel = this.levels.find(levelElement => {
            return levelElement.dataset.level === this.level;
        });

        if (this.activeLevel) {
            this.activeLevel.classList.add('is-active');
            this.activeLevelArrow = this.activeLevel.querySelector('i');
            intersectionHelper.enterViewportOnce(this.element, this.animate.bind(this), {
                threshold: 1.0
            });
        }
    }

    animate() {
        TweenLite.to(this.levels, 2.5, {
            width: '100%',
            onComplete: () => {
                TweenLite.to(this.activeLevelArrow, 0.5, {opacity: 0.6});
            }
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/energy-certificate/js/energy-certificate.component.js